module.exports = __webpack_public_path__ + "img/banner.77eeff0f.png";